"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildBilling = exports.toRecurringFrequency = exports.toCustomDiscount = exports.createPriceContext = exports.buildHeadingTokens = exports.buildDescriptionTokens = exports.createTextToken = exports.createEmptyToken = void 0;
var TokenConverter_1 = require("@CommonFrontend/ContentTokens/TokenConverter");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var createEmptyToken = function (subType) { return ({
    subType: subType,
    type: "block",
}); };
exports.createEmptyToken = createEmptyToken;
var createTextToken = function (content) { return ({
    type: "inline",
    subType: "text",
    content: content,
}); };
exports.createTextToken = createTextToken;
var buildDescriptionTokens = function (description) {
    return description ? (0, TokenConverter_1.textToTokenConverter)(description) : [(0, exports.createEmptyToken)("paragraph"), (0, exports.createTextToken)("")];
};
exports.buildDescriptionTokens = buildDescriptionTokens;
var buildHeadingTokens = function (heading) {
    return heading
        ? (0, TokenConverter_1.textToTokenConverter)(heading, { tokenType: "heading2" })
        : [(0, exports.createEmptyToken)("heading2"), (0, exports.createTextToken)("")];
};
exports.buildHeadingTokens = buildHeadingTokens;
var createPriceContext = function (discounts, taxes, taxExemptions) {
    if (discounts === void 0) { discounts = []; }
    if (taxes === void 0) { taxes = []; }
    if (taxExemptions === void 0) { taxExemptions = []; }
    return ({
        taxes: taxes,
        discounts: discounts,
        taxExemptions: taxExemptions,
    });
};
exports.createPriceContext = createPriceContext;
var toCustomDiscount = function (discount, name) {
    if (name === void 0) { name = "Custom discount"; }
    if (!discount)
        return undefined;
    return {
        type: "custom",
        name: name,
        amountType: discount.type === "fixed" ? "flat" : "percentage",
        amount: discount.amount,
    };
};
exports.toCustomDiscount = toCustomDiscount;
var toRecurringFrequency = function (billing) {
    switch (billing) {
        case "weekly":
            return Types_1.RecurringFrequency.Weekly;
        case "monthly":
            return Types_1.RecurringFrequency.Monthly;
        case "quarterly":
            return Types_1.RecurringFrequency.Quarterly;
        case "yearly":
            return Types_1.RecurringFrequency.Yearly;
    }
};
exports.toRecurringFrequency = toRecurringFrequency;
var buildBilling = function (billingSchedule) {
    if (!billingSchedule || billingSchedule === "one-off") {
        return { type: "one-off" };
    }
    return { type: "recurring", frequency: (0, exports.toRecurringFrequency)(billingSchedule) };
};
exports.buildBilling = buildBilling;
